import React from 'react';
import propTypes from 'prop-types';

export default class EATDPanel extends React.Component {

  static propTypes = {
    onCall: propTypes.func,
  };

  static defaultProps = {
    onCall: null,
  };

  render () {
    return (
      <div className="text-muted">
        EATD does not expose extra admin panel actions here. Use the instance dashboard to manage
        EATD credentials, options, and test flows.
      </div>
    );
  }

}